__turbopack_context__.v({
  "checkboxGroup": "styles-module__27mlrG__checkboxGroup",
  "checkboxInput": "styles-module__27mlrG__checkboxInput",
  "checkboxLabel": "styles-module__27mlrG__checkboxLabel",
  "fieldCheckbox": "styles-module__27mlrG__fieldCheckbox",
  "filterContainer": "styles-module__27mlrG__filterContainer",
  "formBlock": "styles-module__27mlrG__formBlock",
  "formField": "styles-module__27mlrG__formField",
  "formFooter": "styles-module__27mlrG__formFooter",
  "formItem": "styles-module__27mlrG__formItem",
  "formItemBoolean": "styles-module__27mlrG__formItemBoolean",
  "formItemGroup": "styles-module__27mlrG__formItemGroup",
  "formItemMultiple": "styles-module__27mlrG__formItemMultiple",
  "formItemMultipleDropdown": "styles-module__27mlrG__formItemMultipleDropdown",
  "formItemMultipleItem": "styles-module__27mlrG__formItemMultipleItem",
  "formItemMultipleLabel": "styles-module__27mlrG__formItemMultipleLabel",
  "formLabel": "styles-module__27mlrG__formLabel",
  "label": "styles-module__27mlrG__label",
  "labelText": "styles-module__27mlrG__labelText",
  "pillsView": "styles-module__27mlrG__pillsView",
  "radioInput": "styles-module__27mlrG__radioInput",
  "selectBlock": "styles-module__27mlrG__selectBlock",
  "textInput": "styles-module__27mlrG__textInput",
});
